// Import the zustand store instance
import useQuoteStore from "../store/QuoteStore";
import { formatDateT, deformatDateT } from "../../../shared/utils/formatters";
import { updateQuoteFields } from "../../../shared/utils/storeUtils";

const Tq1Mapper = {
  get() {
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};
    const fullLicense = driver.licenceNumber || "";
    return {
      title: driver.titleId ? { value: driver.titleId } : null,
      firstName: driver.forename ?? null,
      lastName: driver.surname ?? null,
      dateOfBirth:
        driver.dateOfBirth && deformatDateT(driver.dateOfBirth) === "01/01/2008"
          ? null
          : deformatDateT(driver.dateOfBirth) ?? null,
      license: fullLicense.slice(0, -5) || null, // First 11 characters
      licenseUser: fullLicense.slice(-5) || null, // Last 5 characters
      datePassedTest:
        deformatDateT(driver.datePassedTest) === "30/12/1899"
          ? null
          : deformatDateT(driver.datePassedTest),
    };
  },
  set(data) {
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};
    updateQuoteFields({
      "risk.drivers.0.titleId": data.title?.value,
      "risk.drivers.0.forename": data.firstName,
      "risk.drivers.0.surname": data.lastName,
      "risk.drivers.0.dateOfBirth": formatDateT(data.dateOfBirth),
      "risk.drivers.0.licenceNumber": driver.licenceNumber
        ? driver.licenceNumber
        : (data.license || "") + (data.licenseUser || ""),
      "risk.drivers.0.datePassedTest": formatDateT(data.datePassedTest),
    });
  },
};

export default Tq1Mapper;
